import styled from 'styled-components';
import type { ScSelectMainProps } from '../types';

interface ScSelectBlockProps extends ScSelectMainProps {
  active?: boolean;
  error: boolean;
  disabled?: boolean;
  selected?: boolean;
  canReset?: boolean;
  lightColoredDropMode?: boolean;
  lightBg?: boolean;
}

export const ScSelectBlock = styled.div<Pick<ScSelectBlockProps, 'active'>>`
  position: relative;
  z-index: ${({ active }) => (active ? '110' : '0')};
`;
